module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 005.9cbf3f82.jpg";